import type { ReportableError } from '@change-corgi/core/errorReporter/common';

import { addScriptWithErrorReporting } from 'src/app/shared/utils/dom';

export async function loadPaypalScripts(
	reportError: (error: ReportableError) => Promise<{
		url?: string | undefined;
	}>,
): Promise<[unknown, unknown, unknown, unknown]> {
	return Promise.all([
		addScriptWithErrorReporting('https://js.braintreegateway.com/web/3.120.2/js/client.min.js', reportError),
		addScriptWithErrorReporting('https://js.braintreegateway.com/web/3.120.2/js/paypal-checkout.min.js', reportError),
		addScriptWithErrorReporting('https://js.braintreegateway.com/web/3.120.2/js/data-collector.min.js', reportError),
		addScriptWithErrorReporting('https://js.braintreegateway.com/web/3.120.2/js/venmo.min.js', reportError),
	]);
}
